import * as React from "react";
import './proofPanel.scss';
import {FontAwesomeIcon}     from "@fortawesome/react-fontawesome";
import {faArrowRotateRight} from '@fortawesome/free-solid-svg-icons';

import {cs}                  from "@Common/react/chain-services";
import {consumeContext}      from "@Common/react/context";
import {ButtonSpinner}       from "@Common/ui-components/loading-spinners/button-spinner";

export const ProofPanel = ({reverseSides, thumbnailBack, thumbnailFront, loading, numOfSides})=> cs(
    consumeContext("apis"),
    () => <div className="preview-d9v">
        <div className="container">
            {numOfSides == 1 || numOfSides > 2 ? <img src={thumbnailFront} xd-qa-type="image" xd-qa-name="Thumbnail Front"></img> :
            !reverseSides ?
                    <>
                        <img src={thumbnailFront} xd-qa-type="image" xd-qa-name="Thumbnail Front"></img>
                        <img src={thumbnailBack} xd-qa-type="image" xd-qa-name="Thumbnail Back"></img>
                    </>
                :
                    <>
                        <img src={thumbnailBack} xd-qa-type="image" xd-qa-name="Thumbnail Back"></img>
                        <img src={thumbnailFront} xd-qa-type="image" xd-qa-name="Thumbnail Front"></img>
                    </>
            }
            {loading ?
            <div className="loading">
                <div className="loading-overlay"></div>
                <span className="loading-text"><ButtonSpinner spinnerColor="black"/><br/>loading...</span>
            </div>
            :
            <div className="hover">
                <div className="hover-overlay"></div>
                <span className="hover-text"><FontAwesomeIcon icon={faArrowRotateRight}/><br/>Click here to refresh the proof.</span>
            </div>}
            <a xd-qa-type="link" xd-qa-name="Click Here For Proof">Click Here</a> or Anywhere on the Image to Refresh This Proof
        </div>
    </div>
);
